import { SearchCheck } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const seo = defineDashboardModule({
  id: "seo",
  nav: [{ group: "Publishing", title: "SEO", to: "/seo", icon: SearchCheck }],
  routes: [
    {
      path: "/seo",
      component: lazyPage(() => import("./routes/seo-page"), "SeoPage"),
    },
  ],
})
